// ============================================================================
// Calendar (ICS) subscription API — the TRAINER's own auto-updating feed URL.
// ----------------------------------------------------------------------------
// A trainer subscribes their Google/Apple/Outlook calendar to a single private,
// token-gated, READ-ONLY URL that surfaces every one of their clients' scheduled
// sessions and keeps them in sync. The token IS the secret (same posture as the
// QR check-in link), so `rotate` revokes a leaked URL and mints a fresh one.
//   • GET  /api/calendar/subscription         → get-or-create the feed URL
//   • POST /api/calendar/subscription/rotate   → revoke + mint a new URL
// The client-portal equivalent lives on clientApi.calendar* (api/client.ts).
// ============================================================================
import { http } from "./http";
import type { CalendarSubscription } from "./types";

export const calendarApi = {
  /** Get-or-create the trainer's stable ICS feed URL (idempotent). */
  subscription: (signal?: AbortSignal) =>
    http.get<CalendarSubscription>("/calendar/subscription", undefined, signal),
  /** Rotate the token: the old URL 404s immediately, returns the new URL. */
  rotate: () =>
    http.post<CalendarSubscription>("/calendar/subscription/rotate"),
};
